/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './MacroRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#getMacros
 */
export const GET_MACROS_QUERY_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_getMacros';
export const GET_MACROS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MACROS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    return chirpClient.call(References.getMacrosRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#getMacro
 */
export const GET_MACRO_QUERY_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_getMacro';
export const GET_MACRO_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MACRO_QUERY_FIELD_NAME,
  args: ['macroId'],
  fetcher(request, ctx) {
    return chirpClient.call(References.getMacroRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#create
 */
export const CREATE_MUTATION_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_create';
export const CREATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_MUTATION_FIELD_NAME,
  args: ['name', 'shortcut', 'description', 'workflowId', 'templateId'],
  fetcher(request, ctx) {
    return chirpClient.call(References.createRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#updateMacro
 */
export const UPDATE_MACRO_MUTATION_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_updateMacro';
export const UPDATE_MACRO_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_MACRO_MUTATION_FIELD_NAME,
  args: ['macroId', 'name', 'description', 'workflowId', 'templateId', 'shortcut'],
  fetcher(request, ctx) {
    return chirpClient.call(References.updateMacroRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#deleteMacro
 */
export const DELETE_MACRO_MUTATION_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_deleteMacro';
export const DELETE_MACRO_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_MACRO_MUTATION_FIELD_NAME,
  args: ['macroId'],
  fetcher(request, ctx) {
    return chirpClient.call(References.deleteMacroRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#hardDeleteMacro
 */
export const HARD_DELETE_MACRO_MUTATION_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_hardDeleteMacro';
export const HARD_DELETE_MACRO_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: HARD_DELETE_MACRO_MUTATION_FIELD_NAME,
  args: ['macroId'],
  fetcher(request, ctx) {
    return chirpClient.call(References.hardDeleteMacroRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.macros.rpc.MacroRpc#runMacro
 */
export const RUN_MACRO_MUTATION_FIELD_NAME = 'com_hubspot_cv_macros_rpc_MacroRpc_runMacro';
export const RUN_MACRO_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: RUN_MACRO_MUTATION_FIELD_NAME,
  args: ['macroId', 'objectIds'],
  fetcher(request, ctx) {
    return chirpClient.call(References.runMacroRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});